export const INITIAL_STATE = {
  openDialog: false,

  onOpenDialog: () => {},
  onCloseDialog: () => {},
};
